import globalDefaultConfig from "mapview-gui-utils/src/globalDefaultConfig.ts";

export const config = {
  ...globalDefaultConfig
}